import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/comfirme-person.svg';
const _withScopeId = n => (_pushScopeId("data-v-ab0546b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mycontent"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "请填写企业资料", -1));
const _hoisted_3 = {
  class: "content-body"
};
const _hoisted_4 = {
  style: 'margin-top: -10px; padding-left: 150px; color: #4D4D4D;'
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "2. 我司资质验证系统已与工商部门联网，请勿提供虚假证件。", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 3. 请提供高清营业执照原件彩色扫描件并在营业执照上手写“用于注册腾讯电脑管家 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("     软件开放平台使用+日期”加盖公司印泥公章后上传扫描件。 ")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 4. 请注意不要遮挡名称及社会信用代码，手写信息及公章置于空白处。 ", -1));
const _hoisted_8 = {
  key: 0,
  class: "login-container"
};
const _hoisted_9 = {
  class: "loginall-bodyclose"
};
const _hoisted_10 = {
  class: "loginall-bodytitle"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "或点击头像授权实名认证", -1));
const _hoisted_12 = {
  class: "loginall-bodypart1"
};
const _hoisted_13 = {
  class: "loginall-bodypart2"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "105px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "height": "85px",
    "width": "85px",
    "margin": "10px 0px 0px 10px"
  }
})], -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loginall-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "请使用已实名的QQ扫码"), /*#__PURE__*/_createElementVNode("div", null, "认证填写的个人信息真实性")], -1));
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  key: 0,
  class: "login-container3"
};
const _hoisted_19 = {
  class: "loginall-body3"
};
const _hoisted_20 = {
  class: "loginall-text3"
};
const _hoisted_21 = {
  style: {
    "margin-left": "-30px"
  }
};
const _hoisted_22 = {
  style: {
    "margin-left": "-30px"
  }
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  key: 0,
  class: "login-container2"
};
const _hoisted_25 = {
  class: "loginall-body2"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loginall-text2"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "-30px",
    "padding-top": "12px"
  }
}, " 已认证成功 ")], -1));
const _hoisted_27 = {
  key: 1,
  class: "login-container3"
};
const _hoisted_28 = {
  class: "loginall-body3"
};
const _hoisted_29 = {
  class: "loginall-text3"
};
const _hoisted_30 = {
  style: {
    "margin-left": "-30px"
  }
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "-30px"
  }
}, " 请确认填写信息与认证身份信息是否一致 ", -1));
const _hoisted_32 = {
  style: 'margin-top: -10px; padding-left: 150px; color: #4D4D4D;'
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 2.请提供公司联系人授权说明，并加盖公司公章后拍照/扫描件上传。 ", -1));
const _hoisted_34 = {
  style: 'padding-top: 35px; padding-left: 150px'
};
const _hoisted_35 = {
  style: 'display: flex; padding-top: 10px; padding-left: 150px'
};
import { ref, reactive, onMounted, onDeactivated } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { filepag } from '@/http/api';
import { REG_TYPES } from '@/utils/index';
import { fileTypeCheck, fileizeCheck } from '@/utils/file';
import { QCInfo } from '@/utils/qqInfo.js';
import { IS_DEV } from '@/config/env';
import { addDeveloper, getAuthCode, confirmRealName, confirmLicense, ensureOneCompany } from '@/http/api';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import router from '@/router';
export default {
  __name: 'CompanyConfirm',
  setup(__props) {
    let store = useStore();
    const $router = useRouter();
    const iframeSrc = encodeURI(IS_DEV ? QCInfo.beta.verify_url : QCInfo.prod.verify_url);
    const form = ref(null);
    const formData = reactive({
      user_name: '',
      // 公司名称
      web_address: '',
      // 公司网址
      business_license: '',
      // 营业资质照片  图片url
      socialize_code: '',
      // 社会信用代码
      linkman: '',
      // 公司联系人
      identity_code: '',
      // 联系人身份证
      authorization: '',
      // 实名认证  图片url
      user_phone: '',
      user_email: '',
      user_address: '',
      checked1: false,
      checked2: false,
      confirmReal: ''
    });
    const isVerify = ref(false);
    const delayCode = ref(false);
    const codeTimeFlag = ref(false);
    const iframeStatus = ref(false); // true 打开 false 关闭

    let resConfirmReal = reactive({
      isCert: 0,
      // 是否实名认证： 0-未实名认证； 1-已实名认证
      isMatch: 0,
      // 实名信息是否匹配：0 - 不匹配； 1 - 匹配
      msg: '',
      certUrl: '',
      isConfirmed: false
    });
    const rules = {
      user_name: [{
        required: true,
        message: '公司名称不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.limits.pattern,
        message: REG_TYPES.limits.message,
        trigger: 'blur'
      }],
      web_address: [{
        pattern: REG_TYPES.webAddress.pattern,
        message: REG_TYPES.webAddress.message,
        trigger: 'blur'
      }],
      business_license: [{
        required: true,
        message: '请上传营业资质照片',
        type: 'error',
        trigger: 'change'
      }],
      confirmReal: [{
        required: true,
        message: '请用已实名的QQ扫码认证填写的个人信息真实性',
        type: 'error',
        // trigger: 'all'
        trigger: 'change'
      }],
      socialize_code: [{
        message: REG_TYPES.socializeCode.message,
        pattern: REG_TYPES.socializeCode.pattern,
        type: 'error',
        trigger: 'blur'
      }, {
        required: true,
        message: '社会信用代码不能为空',
        type: 'error',
        trigger: 'blur'
      }],
      linkman: [{
        required: true,
        message: '公司联系人不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.limits.pattern,
        message: REG_TYPES.limits.message,
        trigger: 'blur'
      }],
      identity_code: [{
        required: true,
        message: '联系人身份证号码不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.idCard.pattern,
        message: REG_TYPES.idCard.message,
        trigger: 'blur'
      }],
      authorization: [{
        required: true,
        message: '请上传联系人授权证明',
        type: 'error',
        trigger: 'change'
      }],
      user_phone: [{
        required: true,
        message: '手机号码不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.mobile.pattern,
        message: REG_TYPES.mobile.message,
        trigger: 'blur'
      }],
      user_email: [{
        required: true,
        message: '邮箱不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.email.pattern,
        message: REG_TYPES.email.message,
        trigger: 'blur'
      }],
      user_address: [{
        required: true,
        message: '联系地址不能为空',
        type: 'error',
        trigger: 'blur'
      }]
    };
    onMounted(() => {
      window.addEventListener('message', handleMessage, false);
      setTimeout(() => {
        delayCode.value = true;
      }, 2000);
    });
    onDeactivated(() => {
      window.removeEventListener('message', handleMessage, false);
    });
    const reConfirm = () => {
      resConfirmReal.isConfirmed = false;
      resConfirmReal.isCert = 0;
      resConfirmReal.isMatch = 0;
    };
    const goCheck = () => {
      $router.push({
        path: '/chooseidentity'
      });
    };
    const toConfirm = () => {
      const certUrl = resConfirmReal.certUrl;
      window.open(certUrl);
    };
    const handleMessage = async e => {
      let data = e.data;
      if (data && data.type && data.type == 'sendVerifyCode') {
        let {
          code
        } = data.data;
        const paramData = {
          name: formData.linkman,
          certId: formData.identity_code,
          code
        };
        const res = await confirmRealName(paramData);
        if (res.result && res.data) {
          const data = res.data;
          resConfirmReal.isConfirmed = true, resConfirmReal.isCert = data.isCert, resConfirmReal.isMatch = data.isMatch, resConfirmReal.msg = data.msg, resConfirmReal.certUrl = data.certUrl;
          if (data.isCert == 1 && data.isMatch == 1) {
            formData.confirmReal = 'true';
          } else {
            formData.confirmReal = '';
          }
        }
        iframeStatus.value = false;
      }
    };
    const linkClick = async value => {
      localStorage.setItem('agreementItem', value);
      window.open('/software-platform/useragreement');
    };
    const gotoClose = () => {
      iframeStatus.value = false;
    };
    const gotoConfirm = () => {
      if (!formData.linkman || !formData.identity_code) {
        MessagePlugin.warning('认证的身份证号和姓名必须填写');
        return;
      }
      setTimeout(() => {
        iframeStatus.value = true;
      }, 200);
    };
    const getCode = async () => {
      const mobile = formData.user_phone;
      if (!mobile) {
        MessagePlugin.warning('请填写手机号再获取验证码！');
        return;
      }
      const paramData = {
        mobile
      };
      const res = await getAuthCode(paramData);
      if (res.result && res.forwardData === 0) {
        MessagePlugin.success('获取手机验证码成功！');
      } else {
        MessagePlugin.error('获取手机验证码失败！');
      }
      codeTimeFlag.value = true;
      setTimeout(() => {
        codeTimeFlag.value = false;
      }, 1000 * 60);
    };
    const checkCode = async () => {
      const mobile = formData.user_phone;
      const code = formData.verifyNum;
      if (mobile && code) {
        const paramData = {
          mobile,
          code
        };
        const res = await getAuthCode(paramData);
        if (res.result && res.forwardData === 0) {
          MessagePlugin.success('短信验证通过！');
          isVerify.value = true;
        } else {
          MessagePlugin.error('短信验证失败！');
        }
      }
    };

    /**
     * @param {UploadFile | UploadFile[]} file
     * @returns {Promise<RequestMethodResponse>}
     */
    const requestMethod = (file, params) => {
      // 营业资质照片 businessLicense 大小5M JPG/PNG
      if (params == 'businessLicense') {
        const typeCheck = fileTypeCheck(file, ['.JPG', '.PNG']);
        if (!typeCheck) {
          return new Promise((resolve, reject) => {
            resolve({
              status: 'fail'
            });
          });
        }
        const sizeCheck = fileizeCheck(file, 5, 'MB');
        if (!sizeCheck) {
          return new Promise((resolve, reject) => {
            resolve({
              status: 'fail'
            });
          });
        }
      }
      // 联系人授权证明 authorization 大小10M JPG/PNG
      if (params == 'authorization') {
        const typeCheck = fileTypeCheck(file, ['.JPG', '.PNG']);
        if (!typeCheck) {
          return new Promise((resolve, reject) => {
            resolve({
              status: 'fail'
            });
          });
        }
        const sizeCheck = fileizeCheck(file, 10, 'MB');
        if (!sizeCheck) {
          return new Promise((resolve, reject) => {
            resolve({
              status: 'fail'
            });
          });
        }
      }
      return new Promise((resolve, reject) => {
        /**
         * @type {{response: {url: string}, error?: string, status: 'success' | 'fail' }}
         */
        const resp = {
          status: 'fail',
          response: {
            url: ''
          }
        };
        let form = new FormData();
        form.append('classify', params);
        form.append('file', file.raw);
        filepag(form).then(res => {
          const {
            https,
            success,
            msg
          } = res.data;
          if (!success) {
            MessagePlugin.error(msg);
            resolve({
              status: 'fail'
            });
          } else {
            resp.status = 'success';
            resp.response.url = https;
            resolve(resp);
          }
        }).catch(e => {
          MessagePlugin.error('上传文件错误！');
        });
      });
    };
    const onSubmit = async ({
      validateResult,
      firstError,
      e
    }) => {
      e.preventDefault();
      // 水滴 选择认证页-企业认证按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '4'
      });
      const identityType = 2;
      const user_name = formData.user_name;
      const linkman = formData.linkman;
      if (validateResult === true) {
        if (!isVerify.value) {
          MessagePlugin.warning('请使用手机短信验证通过后再提交！');
          return;
        }
        if (!formData.checked1) {
          MessagePlugin.warning('请确认信息真实性');
          return;
        }
        if (!formData.checked2) {
          MessagePlugin.warning('请同意腾讯电脑管家软件提供者服务协议');
          return;
        }
        const socializeCode = formData.socialize_code;
        if (!socializeCode) return;
        const rules = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
        const resRule = rules.test(socializeCode);
        if (!resRule) return;
        const enRes = await ensureOneCompany({
          socializeCode
        });
        if (enRes.result && enRes.ensure) {
          const urlAuthorization = formData.authorization[0].response.url;
          const urlBusinessLicense = formData.business_license[0].response.url;
          const tempConf = {
            name: formData.user_name,
            regNum: formData.socialize_code,
            imageKey: urlBusinessLicense
          };
          const paramData = {
            identity_type: identityType,
            user_name: formData.user_name,
            web_address: formData.web_address,
            socialize_code: formData.socialize_code,
            linkman: formData.linkman,
            identity_code: formData.identity_code,
            user_phone: formData.user_phone,
            user_email: formData.user_email,
            user_address: formData.user_address,
            business_license: urlBusinessLicense,
            authorization: urlAuthorization
          };
          const resConf = await confirmLicense(tempConf);
          if (resConf && resConf.result && resConf.data.ret == 0) {
            const ocr_applyid = resConf.data.applyId;
            paramData.ocr_applyid = ocr_applyid;
          }
          const res = await addDeveloper(paramData);
          if (res && res.result && res.realInfoRes) {
            MessagePlugin.success('用户信息认证成功');
            const userStr = localStorage.getItem('user');
            let tempUser = {};
            if (userStr) {
              tempUser = JSON.parse(userStr);
            }
            tempUser.identityType = identityType;
            tempUser.confirmed = 1;
            let resVague = '';
            if (linkman.length == 2) {
              resVague = linkman.substring(0, 1) + '*';
            } else {
              resVague = linkman.substring(0, 1) + '*' + linkman.substring(linkman.length - 1, linkman.length);
            }
            tempUser.vagueName = resVague;
            tempUser.userName = user_name;
            tempUser.confirmed = 1;
            localStorage.setItem('user', JSON.stringify(tempUser));
            router.push({
              path: '/softwarelibrary'
            });
          } else {
            MessagePlugin.error(res.message || '用户信息认证失败');
          }
        } else if (enRes.result && !enRes.ensure) {
          MessagePlugin.warning('当前企业已被注册，请勿重复注册！');
          return;
        }
      } else {
        console.log('Validate Errors: ', firstError, validateResult);
        MessagePlugin.warning(firstError);
      }
    };
    return (_ctx, _cache) => {
      const _component_t_breadcrumbItem = _resolveComponent("t-breadcrumbItem");
      const _component_t_breadcrumb = _resolveComponent("t-breadcrumb");
      const _component_t_input = _resolveComponent("t-input");
      const _component_t_form_item = _resolveComponent("t-form-item");
      const _component_t_upload = _resolveComponent("t-upload");
      const _component_t_link = _resolveComponent("t-link");
      const _component_t_icon = _resolveComponent("t-icon");
      const _component_t_checkbox = _resolveComponent("t-checkbox");
      const _component_t_button = _resolveComponent("t-button");
      const _component_t_space = _resolveComponent("t-space");
      const _component_t_form = _resolveComponent("t-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        style: _normalizeStyle([{
          "height": "1921px",
          "width": "100%",
          "position": "absolute",
          "top": "0",
          "left": "0",
          "background": "#000000",
          "opacity": "0.5",
          "z-index": "90"
        }, iframeStatus.value ? '' : 'display: none'])
      }, null, 4), _createElementVNode("div", _hoisted_1, [_createVNode(_component_t_breadcrumb, {
        style: {
          "width": "680px",
          "margin": "auto",
          "padding-top": "52px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_t_breadcrumbItem, {
          style: {
            "color": "#000"
          },
          onClick: goCheck
        }, {
          default: _withCtx(() => [_createTextVNode("选择认证方式")]),
          _: 1
        }), _createVNode(_component_t_breadcrumbItem, {
          disabled: ""
        }, {
          default: _withCtx(() => [_createTextVNode("填写信息")]),
          _: 1
        })]),
        _: 1
      }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_form, {
        labelWidth: "150px",
        ref_key: "form",
        ref: form,
        data: formData,
        rules: rules,
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_t_form_item, {
          style: 'padding-top: 65px',
          label: "公司名称",
          name: "user_name",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.user_name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.user_name = $event),
            placeholder: "请输入公司名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "官网网址",
          name: "web_address",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.web_address,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.web_address = $event),
            placeholder: "请输入官网网址"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "15px"
          },
          label: "营业资质照片",
          name: "business_license",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_upload, {
            class: "myupload",
            modelValue: formData.business_license,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.business_license = $event),
            theme: "image",
            placeholder: "请上传营业资质照片",
            "request-method": file => requestMethod(file, 'businessLicense')
          }, null, 8, ["modelValue", "request-method"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createTextVNode(" 1. 大小5M以内，JPG/PNG格式的图片 "), _createVNode(_component_t_link, {
          theme: "primary",
          hover: "color",
          href: "https://webcdn.m.qq.com/platform/upload/logo/show.png",
          target: "_blank"
        }, {
          default: _withCtx(() => [_createTextVNode(" 查看示例 ")]),
          _: 1
        })]), _hoisted_5, _hoisted_6, _hoisted_7]), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "45px"
          },
          label: "社会信用代码",
          name: "socialize_code",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.socialize_code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.socialize_code = $event),
            placeholder: "请按照营业执照输入统一社会信用代码",
            maxlength: "18"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "公司联系人",
          name: "linkman",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.linkman,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.linkman = $event),
            placeholder: "请输入联系人姓名",
            maxlength: "30",
            disabled: _unref(resConfirmReal).isConfirmed && _unref(resConfirmReal).isCert == 1 && _unref(resConfirmReal).isMatch == 1
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "身份证",
          name: "identity_code",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.identity_code,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.identity_code = $event),
            placeholder: "请输入联系人有效身份证号",
            maxlength: "30",
            disabled: _unref(resConfirmReal).isConfirmed && _unref(resConfirmReal).isCert == 1 && _unref(resConfirmReal).isMatch == 1
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "实名认证",
          name: "confirmReal",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            style: {
              "display": "none"
            },
            modelValue: formData.confirmReal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.confirmReal = $event),
            placeholder: ""
          }, null, 8, ["modelValue"]), !_unref(resConfirmReal).isConfirmed ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
            class: "loginall-body",
            style: _normalizeStyle(delayCode.value ? '' : 'opacity: 0')
          }, [_createElementVNode("div", {
            style: _normalizeStyle([iframeStatus.value ? '' : 'visibility: hidden', {
              "position": "absolute",
              "top": "-468px",
              "z-index": "99",
              "margin-left": "-21px",
              "width": "480px",
              "height": "360px",
              "background": "rgb(255, 255, 255)",
              "padding": "20px 0px 0px",
              "border-radius": "10px"
            }])
          }, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_t_link, {
            onClick: gotoClose,
            theme: "primary",
            hover: "color",
            style: _normalizeStyle([{
              "position": "absolute"
            }, iframeStatus.value ? '' : 'display: none'])
          }, {
            default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
            _: 1
          }, 8, ["style"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createTextVNode(" 请使用 "), _createVNode(_component_t_link, {
            theme: "primary",
            hover: "color",
            href: "https://im.qq.com/mobileqq/#from=login",
            target: "_blank",
            style: {
              "font-size": "14px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("QQ手机版")]),
            _: 1
          }), _createTextVNode(" 扫描二维码， ")]), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("iframe", {
            id: "qq_login_frame",
            src: _unref(iframeSrc),
            width: "800",
            height: "600",
            scrolling: "no"
          }, "\n                    ", 8, _hoisted_14)])])], 4)], 4), _hoisted_15, _hoisted_16, _createVNode(_component_t_link, {
            onClick: gotoConfirm,
            style: {
              "font-size": "16px",
              "width": "75px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(" 去认证 ")]),
            _: 1
          })])) : _createCommentVNode("", true), _unref(resConfirmReal).isConfirmed ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_unref(resConfirmReal).isCert == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_t_icon, {
            name: "error-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#f24014"
            }
          })]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createTextVNode(" 认证失败 "), _createVNode(_component_t_link, {
            onClick: reConfirm,
            style: {
              "font-size": "16px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(" 重新认证")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_22, [_createTextVNode(" 请确认账号是否完成实名认证 "), _createVNode(_component_t_link, {
            onClick: toConfirm,
            style: {
              "font-size": "16px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode("去实名认证")]),
            _: 1
          })])])])) : _createCommentVNode("", true), _unref(resConfirmReal).isCert == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_unref(resConfirmReal).isMatch == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_t_icon, {
            name: "check-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#00be63"
            }
          })]), _hoisted_26])) : _createCommentVNode("", true), _unref(resConfirmReal).isMatch == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_t_icon, {
            name: "error-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#f24014"
            }
          })]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createTextVNode(" 认证失败 "), _createVNode(_component_t_link, {
            onClick: reConfirm,
            style: {
              "font-size": "16px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(" 重新认证")]),
            _: 1
          })]), _hoisted_31])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "15px"
          },
          label: "联系人授权证明",
          name: "authorization",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_upload, {
            class: "myupload",
            modelValue: formData.authorization,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.authorization = $event),
            theme: "image",
            placeholder: "请上传授权证明",
            "request-method": file => requestMethod(file, 'authorization')
          }, null, 8, ["modelValue", "request-method"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", null, [_createTextVNode(" 1.大小10M以内，JPG/PNG格式的图片 "), _createVNode(_component_t_link, {
          theme: "primary",
          hover: "color",
          href: "https://webcdn.m.qq.com/platform/upload/logo/authorization.docx",
          target: "_blank"
        }, {
          default: _withCtx(() => [_createTextVNode(" 下载模板 ")]),
          _: 1
        })]), _hoisted_33]), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "45px"
          },
          label: "联系电话",
          name: "user_phone",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            disabled: isVerify.value,
            modelValue: formData.user_phone,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.user_phone = $event),
            maxlength: "11",
            placeholder: "请输入手机号"
          }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_t_link, {
            disabled: isVerify.value || codeTimeFlag.value,
            onClick: _cache[9] || (_cache[9] = $event => getCode()),
            theme: "primary",
            hover: "color",
            style: {
              "position": "absolute",
              "right": "15px",
              "z-index": "9"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(codeTimeFlag.value ? '重新发送' : '获取验证码'), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            disabled: isVerify.value,
            modelValue: formData.verifyNum,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.verifyNum = $event),
            placeholder: "请输入手机验证码",
            maxlength: "10"
          }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_t_link, {
            disabled: isVerify.value,
            onClick: _cache[11] || (_cache[11] = $event => checkCode()),
            theme: "primary",
            hover: "color",
            style: {
              "position": "absolute",
              "right": "15px",
              "z-index": "9"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" 确认验证 ")]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "联系邮箱",
          name: "user_email",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.user_email,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.user_email = $event),
            placeholder: "请输入日常使用的邮箱地址，方便我们联系您",
            maxlength: "56"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "公司地址",
          name: "user_address",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.user_address,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.user_address = $event),
            placeholder: "示例：深圳市南山区深南大道xx号x号楼x单元xxx",
            maxlength: "48"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_34, [_createVNode(_component_t_checkbox, {
          modelValue: formData.checked1,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formData.checked1 = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("我确认以上信息真实性，并同意平台审核及留存")]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_35, [_createVNode(_component_t_checkbox, {
          modelValue: formData.checked2,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formData.checked2 = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("同意")]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", null, [_createVNode(_component_t_link, {
          theme: "primary",
          hover: "color",
          onClick: _cache[16] || (_cache[16] = $event => linkClick('item2'))
        }, {
          default: _withCtx(() => [_createTextVNode("腾讯电脑管家软件开放平台开发者协议")]),
          _: 1
        })])]), _createVNode(_component_t_form_item, {
          style: 'padding-top: 40px; padding-bottom: 100px'
        }, {
          default: _withCtx(() => [_createVNode(_component_t_space, {
            size: "small"
          }, {
            default: _withCtx(() => [_createVNode(_component_t_button, {
              style: 'width: 150px',
              theme: "primary",
              type: "submit"
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])], 64);
    };
  }
};